enum EnvProdEnum {
    CZ = "cz",
    SK = "sk"
}

export default EnvProdEnum;
